import React from "react";
import { withRouter } from "react-router-dom";
import LoadSpinner from "../../../common/spinner/loadSpinner";
import Menucustom from "../../../common/menu/menucustom";
import dashboardLineaMezzoService from "./dashboardLineaMezzoService";
import { Form, InputGroup } from "react-bootstrap";
import { BsFillCircleFill } from "react-icons/bs";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import NumberFormat from "react-number-format";
import {
  calculateTimeDifferenceTwoDates,
  geDataFormat,
  getColorState,
} from "../../../common/utils";
import { CDBCard, CDBCardBody, CDBDataTable, CDBContainer } from "cdbreact";
import { CSVLink, CSVDownload } from "react-csv";
import ingiunzioniList from "../../../common/mookup/MookUpIngunzioni";
import { Modal, Button, Row } from "react-bootstrap";
toast.configure();

class DashboardLineaMezzo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        listLineaMezzo:[],
        listLineaMezzoOld:[],
        loading: false,
        loadingButton: false,
        idDaEliminare: null,
        showDeleteModal: false,
        showAddLineaModal: false,
        newLineaDescription: "",

    };
    this.dashboardLineaMezzoService = new dashboardLineaMezzoService();
  }

  componentDidMount() {
    this.getListLineaMezzo();
  }

  getListLineaMezzo() {
    this.setState({ loading: true });
    this.dashboardLineaMezzoService.getLineaMezzo(
      (result) => {

        result.map((lineaMezzo) => {
          lineaMezzo.statobottne = true;
          lineaMezzo.bottoniEditi = true;

        });
        this.setState({ listLineaMezzo: result });
        this.setState({ listLineaMezzoOld: result });
        this.setState({ loading: false });
      },
        ()=>{
            toast.error("Qualcosa è andato storto,Riprova");
            this.setState({ loading: false });
        }
    );
  }


  confermaElimina() {
    this.setState({ loadingButton: true})
    this.dashboardLineaMezzoService.deleteLineaMezzo(
      this.state.idDaEliminare,
      (result) => {
        toast.success("Eliminato con successo");
        this.setState({ showDeleteModal: false });
        this.setState({ idDaEliminare: null });
        this.getListLineaMezzo();
        this.setState({ loadingButton: false });
      },
      ()=>{
        toast.error("Qualcosa è andato storto,Riprova");
        this.getListLineaMezzo();
        this.setState({ showDeleteModal: false });
        this.setState({ loadingButton: false });
      }
      );
  }

  eliminaModal() {
    return (
      <>
        <Modal size="lg" show={this.state.showDeleteModal}>
          <Modal.Header>
            <Modal.Title>Elimina Linea Mezzo</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Sei sicuro di eliminare la linea mezzo?
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={()=>{
                this.setState({ showDeleteModal: false })
                this.setState({ idDaEliminare: null })
              }
              }
            >
              Annulla
            </Button>
            <Button variant="danger" disabled={this.state.loadingButton} onClick={this.confermaElimina.bind(this)}>
              {this.state.loadingButton ? <LoadSpinner/> : "Elimina Linea Mezzo"}
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }


  confermaAggiungi() {
    this.setState({ loadingButton: true });
    this.dashboardLineaMezzoService.createLineaMezzo(
      {descrizione:this.state.newLineaDescription},
      (result) => {
        this.setState({ loadingButton: false });

        toast.success("Aggiunto con successo");
        this.setState({showAddLineaModal:false})
        this.setState({newLineaDescription:""})
        this.getListLineaMezzo();
      },
      ()=>{
        this.setState({ loadingButton: false })
        this.setState({showAddLineaModal:false})
        toast.error("Qualcosa è andato storto,Riprova")
        this.setState({newLineaDescription:""})
      }
    );
  }


  newLineaInputHandler(event) {
    this.setState({ newLineaDescription: event.target.value });

  }

  addNewLineaModal() {
    return (
      <>
        <Modal size="lg" show={this.state.showAddLineaModal}>
          <Modal.Header>
            <Modal.Title>Aggiungi una nuova linea mezzo</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <label>Linea Mezzo</label>
            <input
              className="form-control"
              type="text"
              value={this.state.newLineaDescription}
              onChange={this.newLineaInputHandler.bind(this)}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={()=>{
                this.setState({showAddLineaModal:false})
                this.setState({newLineaDescription:""})
              }}
            >
              Annulla
            </Button>
            <Button
              variant="primary"
              disabled={this.state.loadingButton || this.state.newLineaDescription.length < 1}
              onClick={this.confermaAggiungi.bind(this)}
            >
              {this.state.loadingButton ? <LoadSpinner/> : "Aggiungi Linea mezzo"}
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }

  onChangeEditLineaMezzo(event) {
    const index = event.target.id;
    let list = JSON.parse(JSON.stringify(this.state.listLineaMezzo));
    list[index].descrizione = event.target.value;
    this.setState({ listLineaMezzo: list });
  }

  confermaEditLineaMezzo(index){
    let doc = JSON.parse(JSON.stringify(this.state.listLineaMezzo[index]));
    let obj = {idLineaMezzo:doc.idLineaMezzo,descrizione:doc.descrizione,attivo:doc.attivo}

    this.dashboardLineaMezzoService.editLineaMezzo(obj,(result)=>{
            this.getListLineaMezzo();
            toast.success("Modificato con successo");

    },()=>{
        toast.error("Qualcosa è andato storto")
        this.getListLineaMezzo();
    })
  }




  tabellaLineaMezzo() {
    return (
      <>
        <table class="table table-bordered text-center">
          <thead>
            <tr>
              <th scope="col">Linea Mezzo</th>
              <th scope="col">Azioni</th>
            </tr>
          </thead>
          <tbody>
            {this.state.listLineaMezzo.map((lineaMezzo, index) => {
              return (
                <>
                  <tr className="">
                    <th className="col-md-3">
                      <input
                        id={index}
                        disabled={lineaMezzo.statobottne}
                        className="form-control"
                        type="text"
                        value={lineaMezzo.descrizione}
                        onChange={this.onChangeEditLineaMezzo.bind(this)}
                      />
                    </th>
                    <td>
                      {lineaMezzo.bottoniEditi ? (
                        <>
                          <button
                            className="btn btn-primary"
                            onClick={() => {
                              let list = this.state.listLineaMezzo
                              let obj =  JSON.parse(JSON.stringify(list[index]))
                              obj.bottoniEditi = false
                              obj.statobottne = false
                              list[index] = obj
                              this.setState({listLineaMezzo:list})
                            }}>
                            {" "}
                            <i className="fas fa-fw fa-edit"></i>{" "}
                          </button>
                          &nbsp;
                          <button
                            className="btn btn-danger"
                            onClick={() =>
                              this.setState({
                                idDaEliminare:lineaMezzo.idLineaMezzo,
                                showDeleteModal: true,
                              })
                            }
                          >
                            {" "}
                            <i className="fas fa-fw fa-trash"></i>{" "}
                          </button>
                          &nbsp;
                        </>
                      ) : (
                        <>
                          <button
                            className="btn btn-success"
                            disabled={this.state.loadingButton}
                            onClick={() => this.confermaEditLineaMezzo(index)}>
                            {" "}
                            {this.state.loadingButton ? <LoadSpinner/> : <i className="fas fa-fw fa-check"></i>}
                            {" "}
                          </button>
                          &nbsp;
                          <button
                            className="btn btn-danger"
                            id={index}
                            onClick={() => {
                              let list = JSON.parse(JSON.stringify(this.state.listLineaMezzo))
                              let obj =  list[index]
                              obj.bottoniEditi = true
                              obj.statobottne = true
                              obj.descrizione = this.state.listLineaMezzoOld[index].descrizione

                              this.setState({listLineaMezzo:list})
                            }}
                          >
                            {" "}
                            <i className="fas fa-fw fa-times"></i>{" "}
                          </button>
                          &nbsp;
                        </>
                      )}
                    </td>
                  </tr>
                </>
              );
            })}
          </tbody>
        </table>
      </>
    );
  }
  render() {
    let content = this.state.loading ? (
      <LoadSpinner />
    ) : (
      <div id="wrapper">
        <Menucustom />
        <div className="container-fluid">
          <br />
          <br />
          <div className="d-sm-flex align-items-center justify-content-between mb-4">
            <h1 className="h1 mb-2 text-gray-800">
              Gestione Linea Mezzo<br></br>
            </h1>

            <button
              type="button"
              class="btn btn-warning"
              onClick={() => {
                this.setState({ showAddLineaModal: true });
              }}
            >
              {" "}
              <i className="fas fa-plus fa-sm text-white"></i> Aggiungi
              una nuova Linea Mezzo
            </button>
            <a className=""></a>
          </div>
          <br />
          <br />
          <div className="col">{this.tabellaLineaMezzo()}</div>
          {this.eliminaModal()}
           {this.addNewLineaModal()}
        </div>
      </div>
    );
    return <div>{content}</div>;
  }
}
export default withRouter(DashboardLineaMezzo);
